import Confirmation from './Confirmation';
import Landing from './Landing';

const VerifyEmail = {
  Landing,
  Confirmation,
};

export default VerifyEmail;
